export var white = '#FFFFFF';
export var black = '#00081C';
export var brandBlue = black;
export var brand = black;
export var lightBlack = '#273751';
export var gold = '#CDBC7A';
export var brandGold = gold;
export var productGold = '#DFC96C';
export var productRoseGold = '#e5ae87';
export var productSilver = '#c1c1c1';
export var roseGold = productRoseGold;
export var silver = productSilver;
export var grey1 = '#6E6E6E';
export var grey2 = '#979797';
export var grey3 = '#C7C7C7';
export var grey4 = '#DDDDDD';
export var grey5 = '#F4F4F4';
export var green = '#007947';
export var support1a = green;
export var lightGreen = '#ECF5F1';
export var support1b = lightGreen;
export var red = '#D80000';
export var support2a = red;
export var lightRed = '#FFEFEF';
export var support2b = lightRed;
export var support3a = '#786C3C';
export var support3b = '#F5F2E4';
export var support4a = '#5F6D8E';
export var support4b = '#ECF0FB';
export var yellow = '#F7C111';
export var kaytBrandBlue = '#0E448F';
export var kaytBlue2 = '#3E69A5';
export var kaytBlue3 = '#6E8FBC';
export var kaytBlue4 = '#9FB4D2';
export var kaytBlue5 = '#CFDAE9';
export var kaytBlue6 = '#E6ECF3';
export var colors = {
  brand: [brandBlue, brandGold],
  product: [productRoseGold, productSilver, productGold],
  uiShades: [grey1, grey2, grey3, grey4, grey5, white],
  support: [support1a, support1b, support2a, support2b, support3a, support3b, support4a, support4b],
  status: [yellow],
  kayt: [kaytBrandBlue, kaytBlue2, kaytBlue3, kaytBlue4, kaytBlue5, kaytBlue6]
};